import { render, staticRenderFns } from "./table.vue?vue&type=template&id=a36a66fe&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a66fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36a66fe')) {
      api.createRecord('a36a66fe', component.options)
    } else {
      api.reload('a36a66fe', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=a36a66fe&scoped=true", function () {
      api.rerender('a36a66fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/channelManage/components/table.vue"
export default component.exports